import $ from 'jquery';

const ratingStarSelector = {
    bindEvents: function() {
        this.$list
            .on(
                'mouseover',
                'li',
                function(e) {
                    this.update($(e.currentTarget).data());
                }.bind(this)
            )
            .on('mouseout', this.reset.bind(this));
    },
    findMessageByRating: function(rating) {
        return this.$list.find('li[data-rating="' + rating + '"]').data('msg');
    },
    reset: function() {
        this.update({
            count: this.defaultCount,
            rating: this.defaultRating,
            msg: this.defaultMessage
        });
    },
    resetRating: function() {
        this.$list.removeClass('rate0 rate1 rate2 rate3 rate4 rate5');
    },
    setRating: function(rating) {
        this.resetRating();
        this.$list.addClass('rate' + rating);
    },
    setMessage: function(msg) {
        this.$msg.text(msg);
    },
    setCount: function(count) {
        this.$count.text(count);
    },
    update: function(data) {
        this.setCount(data.count);
        this.setRating(data.rating);
        this.setMessage(data.msg);
    },
    init: function() {
        var $el = (this.$el = $('#ratingStars')),
            $count = (this.$count = $el.find('.ratingCount > span')),
            $msg = (this.$msg = $el.find('.ratingMessage')),
            defaultRating = (this.defaultRating = $el.data('defaultRating'));
        this.$list = $el.find('.ratingList');
        this.defaultCount = $count.text();
        this.defaultMessage = defaultRating ? this.findMessageByRating(defaultRating) : $msg.text();
        this.setMessage(this.defaultMessage);
        this.bindEvents();
    }
};

export default ratingStarSelector;
